"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var token_type_1 = require("./token-type");
Object.defineProperty(exports, "TokenType", { enumerable: true, get: function () { return token_type_1.TokenType; } });
